import type { HTMLAttributes } from "react";
import { cn } from "@design-lab/shared/lib";

type SpaceHolderItemProps = HTMLAttributes<HTMLDivElement> & {
  visible?: boolean;
};

export function SpaceHolderItem(props: SpaceHolderItemProps) {
  const { visible = true, className, ...rest } = props;

  return (
    <div {...rest} className={cn(className, "[grid-area:1/1/2/2]", !visible && "invisible")} />
  );
}
